import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=264a1a2f"
import script from "./Project.ts?vue&type=script&lang=ts&external"
export * from "./Project.ts?vue&type=script&lang=ts&external"
import style0 from "./Project.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports